'use strict';

angular.module('DynamicForms', []);